import { Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export const ModeratorProtectedRoute = ({ children, user }) => {
  const [isModerator, setIsModerator] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkModeratorRole = async () => {
      console.log("ModeratorProtectedRoute: Checking moderator role for user:", user?.uid);
      console.log("ModeratorProtectedRoute: User email:", user?.email);
      console.log("ModeratorProtectedRoute: User object:", user);
      
      if (!user) {
        console.log("ModeratorProtectedRoute: No user found");
        setLoading(false);
        return;
      }

      try {
        // Get user document from Firestore to check role
        const userDocRef = doc(db, "users", user.uid);
        console.log("ModeratorProtectedRoute: Getting user document for:", user.uid);
        console.log("ModeratorProtectedRoute: Document path:", userDocRef.path);
        
        // Also try with email as document ID (in case that's how it was created)
        const emailDocRef = doc(db, "users", user.email);
        console.log("ModeratorProtectedRoute: Also checking email-based document:", user.email);
        
        const [userDoc, emailDoc] = await Promise.all([
          getDoc(userDocRef),
          getDoc(emailDocRef)
        ]);
        
        console.log("ModeratorProtectedRoute: UID document exists?", userDoc.exists());
        console.log("ModeratorProtectedRoute: Email document exists?", emailDoc.exists());
        
        let userData = null;
        
        if (userDoc.exists()) {
          userData = userDoc.data();
          console.log("ModeratorProtectedRoute: Using UID document - User data found:", userData);
        } else if (emailDoc.exists()) {
          userData = emailDoc.data();
          console.log("ModeratorProtectedRoute: Using EMAIL document - User data found:", userData);
        }
        
        if (userData) {
          console.log("ModeratorProtectedRoute: Raw role value:", JSON.stringify(userData.role));
          console.log("ModeratorProtectedRoute: Role type:", typeof userData.role);
          console.log("ModeratorProtectedRoute: All fields in document:", Object.keys(userData));
          
          // Allow access for both admin and moderator roles (case-insensitive)
          const userRole = userData.role?.toLowerCase?.() || '';
          const isUserModerator = userRole === "admin" || userRole === "moderator";
          console.log("ModeratorProtectedRoute: Normalized role:", userRole);
          console.log("ModeratorProtectedRoute: Is user moderator/admin?", isUserModerator, "Original Role:", userData.role);
          setIsModerator(isUserModerator);
        } else {
          console.log("ModeratorProtectedRoute: No user document found with UID or email");
          console.log("ModeratorProtectedRoute: Please manually set user role using setUserRole function");
          setIsModerator(false);
        }
      } catch (error) {
        console.error("ModeratorProtectedRoute: Error checking moderator role:", error);
        setIsModerator(false);
      } finally {
        setLoading(false);
      }
    };

    checkModeratorRole();
  }, [user]);

  console.log("ModeratorProtectedRoute: Render - loading:", loading, "user:", !!user, "isModerator:", isModerator);

  if (loading) {
    return <div>Loading...</div>; // Or your loading component
  }

  if (!user) {
    console.log("ModeratorProtectedRoute: Redirecting to / - no user");
    return <Navigate to="/" replace />;
  }

  if (!isModerator) {
    console.log("ModeratorProtectedRoute: Redirecting to /plans - not moderator/admin");
    return <Navigate to="/plans" replace />; // Redirect to regular user area
  }

  console.log("ModeratorProtectedRoute: Allowing access to moderator area");
  return children;
};
